import { render, staticRenderFns } from "./ModernUi.vue?vue&type=template&id=5d0773f0&scoped=true&"
import script from "./ModernUi.vue?vue&type=script&lang=js&"
export * from "./ModernUi.vue?vue&type=script&lang=js&"
import style0 from "./ModernUi.vue?vue&type=style&index=0&id=5d0773f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0773f0",
  null
  
)

export default component.exports